import { type Coord, coordToA1 } from "./coord-translation";

// --- Formula ref building ----------------------------------------------------
// Build A1 refs from coords and splice into the formula buffer's arg list
// (between first `(` and last `)`). "replace" overwrites, "append" comma-appends.

export type PickMode = "replace" | "append";

export const buildRefFromCoords = (start: Coord, end: Coord): string => {
  if (start.col === end.col && start.row === end.row) {
    return coordToA1(start);
  }
  const minCol = Math.min(start.col, end.col);
  const maxCol = Math.max(start.col, end.col);
  const minRow = Math.min(start.row, end.row);
  const maxRow = Math.max(start.row, end.row);
  return `${coordToA1({ col: minCol, row: minRow })}:${coordToA1({
    col: maxCol,
    row: maxRow,
  })}`;
};

export const insertRefIntoBuffer = (
  buffer: string,
  newRef: string,
  mode: PickMode,
): string => {
  const openIdx = buffer.indexOf("(");
  const closeIdx = buffer.lastIndexOf(")");
  if (openIdx < 0 || closeIdx <= openIdx) {
    return buffer + newRef;
  }
  const before = buffer.slice(0, openIdx + 1);
  const after = buffer.slice(closeIdx);
  const args = buffer.slice(openIdx + 1, closeIdx).trim();

  const newArgs =
    mode === "append" && args.length > 0 ? `${args},${newRef}` : newRef;

  return `${before}${newArgs}${after}`;
};

// --- Formula edit target -----------------------------------------------------

export interface IFormulaEditTarget {
  entityId: string;
  cellId: string;
}

// Cell ids are table-local, so match on entityId too to scope the edit.
export const formulaEditTargetsCell = (
  formulaEdit: IFormulaEditTarget | null | undefined,
  entityId: string,
  cellId: string,
): boolean =>
  !!formulaEdit &&
  formulaEdit.entityId === entityId &&
  formulaEdit.cellId === cellId;
